import * as Sentry from '@sentry/react';
import { USER_SESSION_INFO } from '../okta';
import envConfig from '../config/config';

Sentry.init({
  dsn: envConfig.sentry.dsn,
  enabled: envConfig.sentry.enabled,
  environment: envConfig.sentry.environment,
  release: envConfig.sentry.release,
  dist: envConfig.sentry.dist,
  integrations: [Sentry.browserTracingIntegration(), Sentry.browserProfilingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'https://local.devtempus.com:3000',
    /^https:\/\/.*\.((staging|dev|secure|validation)tempus\.com)$/,
    /^https:\/\/.*\.((alp|bet|val|prd)\.gcp\.tempus\.cloud)$/,
  ],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
});

export class Logger {
  constructor(name) {
    this.name = name;
  }

  info(...args) {
    console.log(...args);
  }

  debug(...args) {
    console.debug(...args);
  }

  warn(...args) {
    console.warn(...args);
  }

  error(error, ...params) {
    console.error(error, ...params);
    const userInfo = window.sessionStorage.getItem(USER_SESSION_INFO);

    const sentryArgs = { tags: { ...params, userInfo, loggerName: this.name } };
    if (typeof error === 'string') {
      Sentry.captureMessage(error, sentryArgs);
    } else {
      Sentry.captureException(error, sentryArgs);
    }
  }
}

const logger = new Logger('default');

window.addEventListener('error', function (event) {
  logger.error(event.error);
});

export default logger;
